<script>
import UserActionRequired from './userActionRequired/UserActionRequired.vue'
import ScheduleSelection from './schedule/ScheduleSelection.vue'
import ScheduleConfirmation from '@/components/document-validation/schedule/ScheduleConfirmation.vue'
export default {
  components: { ScheduleConfirmation, UserActionRequired, ScheduleSelection },
  props: {
    nextStep: { type: Function },
    isDisabled: { type: Boolean },
    emptyList: { type: Boolean },
    loading: { type: Boolean },
    loadingConfirmWarnings: { type: Boolean },
    userActionRequired: { type: Object },
    userActionRequiredDisabled: { type: Boolean },
    order: { type: Object }
  },
  data: () => ({
    isSubmitting: false,
    selectedSchedule: { type: null, date: null },
    ScheduleConfirmation: { state: false, date: '' }
  }),
  computed: {
    scheduleSelection() {
      return (!this.isDisabled && !this.loading ) }
  },
  methods: {
    handleClick() {
      if (this.selectedSchedule.type === null || this.selectedSchedule.type === this.$enums.ScheduledType.Instantly) {
        this.setPaymentOpen()}
      if (this.selectedSchedule.type === this.$enums.ScheduledType.Custom || this.selectedSchedule.type === 3) {
        this.setAutoComplete()
      }
      this.$store.commit('TRUNCATE_MERGED_COVERSHEETS')
    },
    setPaymentOpen() {
      this.isSubmitting = true
      this.$ordersService
        .setPaymentOpen(this.order.orderId)
        .then(setPaymentOpenResponse => {
          const { status, response } = setPaymentOpenResponse
          const { OrderNotFound, RequiredDataMissing, WrongOrderStatus } = this.$enums.PaymentOpenResponseStatus
          if (status === 1)
            this.nextStep({ originStep: 2, response: response })
          else {
            switch (status) {
              case OrderNotFound:break
              case RequiredDataMissing:
                this.$emit('update:userProfileRequired', true)
                break
              case WrongOrderStatus:break
              default:break} }
        })
        .catch(e => {
          if (e.response && e.response.status === 400) {
            this.$emit('update:error', true)} })
        .finally(() => {
          this.isSubmitting = false })
    },
    setAutoComplete() {
      this.isSubmitting = true
      this.$ordersService
        .setAutoComplete({
          orderId: this.order.orderId,
          productionDate: this.setProductionDate() })
        .then(response => {
          this.ScheduleConfirmation.date = this.momentDate(
            response.orderSchedule.autocompletionDate
          ).format('DD.MM.YYYY HH:mm:ss')
          this.ScheduleConfirmation.state = true })
        .catch(e => {
          if (e.response && e.response.status === 400) {
            this.$emit('update:error', true)} })
        .finally(() => {
          this.isSubmitting = false })
    },
    setProductionDate() {
      if (this.selectedSchedule.type === this.$enums.ScheduledType.Custom && this.selectedSchedule.date) {
        const date = this.momentDate(this.selectedSchedule.date.date || new Date())
        const time = this.selectedSchedule.date.time || { hour: 14, minutes: 0 }
        return this.momentDate({
          year: date.year(),
          month: date.month(),
          day: date.format('D'),
          hour: time.hour,
          minute: time.minutes }) }
      return null }
  }
}
</script>
<template>
  <v-row v-if="!loading">
    <v-col cols="12" class="pt-0">
      <v-card flat>
        <v-card-title>
          <h4 class="wordBreak">{{
              $t('component.documentValidation.documentValidationNextStep.next.step.header') }}</h4>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <ScheduleConfirmation
            :value="ScheduleConfirmation.state"
            :date="ScheduleConfirmation.date" />
          <UserActionRequired
            :value="userActionRequired"
            :loading="loadingConfirmWarnings"
            :disabled="userActionRequiredDisabled"
            :order-id="order.orderId"
            @confirmWarnings="$emit('confirmWarnings')" />
          <ScheduleSelection
            v-if="scheduleSelection"
            v-model="selectedSchedule"
            :order="order"
            :loading="loading"
            :disabled="isDisabled"
            :submitting="isSubmitting"
            :empty-list="emptyList"
            @handleClick="handleClick" />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-row justify="center" align="center">
        <v-col cols="12" sm="4" md="8"></v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="12" sm="4" md="8"></v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
